/* eslint-disable no-unused-vars */
import React, { Fragment, useState } from "react"
import {
  Button,
  styled,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import EditIcon from "@mui/icons-material/Edit"
import InfoIcon from "@mui/icons-material/Info"
import getUSer from "../services/getUser"
import setPasswordUser from "../services/setPassword"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import ErrorIcon from "@mui/icons-material/Error"
import Divider from "@mui/material/Divider"
import notifyUserEAuthCAC from "../services/notifyUserEAuthCAC"
import CircularProgress from "@mui/material/CircularProgress"
import getProductsUser from "../services/getProductsUser"
import generateJwt3 from "../services/generateJwt3"
import parser from "../../../../utils/Parser"
import handleGetUserLoginAccountData from "../services/getUserLoginAccountData"
import { useDispatch } from "react-redux"
import { updateUserStatusLoginAccount } from "../../../../redux/actions/User"
import { ConfirmModalCognito } from "../../../../components/Modals/Users/Cognito/ConfirmModal"
import { es } from 'date-fns/locale'

const BoxRoot = styled(Box)(() => ({
  width: "100%",
  height: "100vh",
  overflow: "auto",
}))

const InputContainer = styled(Box)(() => ({
  width: "40rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  marginLeft: "2rem",
}))

const BoxInput = styled(Box)(() => ({
  height: "100%",
  width: "40rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  color: "#2C3532",
  fontSize: 15,
  fontFamily: "roboto",
}))

const BoxInputsContainer = styled(Box)(() => ({
  height: "100%",
  width: "40rem",
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignContent: "center",
  gap: "1.5rem",
  marginBottom: "2rem",
}))

const BoxTable = styled(Box)(() => ({
  width: "40rem",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  marginLeft: "2rem",
  marginBottom: "2rem",
}))

const TextError = styled(Typography)(() => ({
  color: "red",
}))

const InputButton = styled(Button)(() => ({
  borderRadius: "5rem",
  fontSize: "14px",
  background: "#1C846F",
  "&:hover": {
    background: "#0CABA8",
  },
}))

const UserAdministrationDesktop = () => {
  const dispatch = useDispatch()
  const [username, setUsername] = useState("")
  const [openModal, setopenModal] = useState(false)
  const [status2FA, setStatus2FA] = useState(false)
  const [expiredDate, setexpiredDate] = useState(null)
  const [disableexpiredDate, setdisableexpiredDate] = useState(null)
  const [disabledExpiredDateBoolean, setdisabledExpiredDateBoolean] = useState(true)

  const [loginAccountId, setloginAccountId] = useState(null)
  const [user, setUser] = useState(null)
  const [showTable, setShowTable] = useState(null)
  const [error, setError] = useState(false)
  const [password, setPassword] = useState("")
  const [errorPass, setErrorPass] = useState(false)
  const [showSuccessIcon, setShowSuccessIcon] = useState(false)
  const [showCircularProgress, setShowCircularProgress] = useState(false)
  const [showCircularProgressJWT3, setShowCircularProgressJWT3] =
    useState(false)
  const [errorLogin, setErrorLogin] = useState(false)
  const [errorGetProducts, setErrorGetProducts] = useState(false)
  const [showCircularProgressProducts, setShowCircularProgressProducts] =
    useState(false)
  const messageTooltip =
    "Para ejecutar esta funcionalidad debe estar conectado a la VPN y tener usuario en el admin2."

  const handleFind = () => {
    setError(false)
    setErrorPass(false)
    setShowTable(false)
    setPassword("")
    setShowSuccessIcon(false)
    setErrorLogin(false)
    setShowCircularProgress(true)

    getUSer(username, (state) => {
      if (state) {
        setUser(state)
        setShowTable(true)
        setShowCircularProgress(false)
        return
      }

      setShowTable(false)
      setError(true)
      setShowCircularProgress(false)
    })
    handleGetUserAccountData(username)
  }

  const handleSetPassword = () => {
    setShowSuccessIcon(false)
    setErrorPass(false)

    if (password === "") return setErrorPass(true)

    setPasswordUser({ username: username, password: password }, (state) => {
      if (state) {
        setErrorPass(false)
        setShowSuccessIcon(true)
      } else {
        setErrorPass(true)
        setShowSuccessIcon(false)
      }
    })
  }
  const getMEUrl = () => {
    const environment = parser.getEnvironment()

    if (environment === "UAT") {
      return process.env.REACT_APP_ME_URL_UAT
    }
    if (environment === "DEV") {
      return process.env.REACT_APP_ME_URL_DEV
    }
    return process.env.REACT_APP_ME_URL_PROD
  }

  const handleLogin = () => {
    setShowCircularProgress(true)
    setErrorLogin(false)

    notifyUserEAuthCAC(username, " ", (state) => {
      setShowCircularProgress(false)

      if (!state) {
        return setErrorLogin(
          "Ocurrió un error interno. Intente más tarde o comuníquese con Desarrollo.",
        )
      }

      if (state.code) {
        return setErrorLogin(
          `Problemas en la asociación de datos. Error al invocar la api:  ${state.api}`,
        )
      }

      window.open("https://www.errepar.com")
    })
  }
  const handleGetUserAccountData = async (email) => {
    const user = await handleGetUserLoginAccountData(email)
    if (user.error) return
    setloginAccountId(user.loginAccountId)
    setStatus2FA(user.isActive)
    const date = new Date(user.expirationDate)
    setexpiredDate(date)
    setdisableexpiredDate(date.toISOString().split("T")[0])
  }
  const changeStatus2FA = () => {
    setopenModal(true)
  }

  const changeExpiredDate2FA = async () => {
    const value = {
      loginAccountId,
      auth_2faExpirationDate: expiredDate.toISOString().split("T")[0],
    }
    await dispatch(updateUserStatusLoginAccount(value))

    setdisableexpiredDate(expiredDate.toISOString().split("T")[0])
    setdisabledExpiredDateBoolean(true)
  }
  const handleUpdatetUserAccountData = async () => {
    setShowCircularProgress(true)
    const value = {
      loginAccountId,
      auth_2faEnabled: !status2FA,
    }

    await dispatch(updateUserStatusLoginAccount(value))
    setStatus2FA(!status2FA)
    setShowCircularProgress(false)

  }
  const handleLoginME = () => {
    setShowCircularProgressJWT3(true)
    notifyUserEAuthCAC(username, "ME", (state) => {
      if (!state) {
        return setErrorLogin(
          "Ocurrió un error interno. Intente más tarde o comuníquese con Desarrollo.",
        )
      }

      if (state.code) {
        return setErrorLogin(
          `Problemas en la asociación de datos. Error al invocar la api:  ${state.api}`,
        )
      }
      generateJwt3(state.data, (result) => {
        setShowCircularProgressJWT3(false)
        if (!result) {
          return setErrorLogin(
            "Ocurrió un error interno. Intente más tarde o comuníquese con Desarrollo.",
          )
        }

        if (result.code) {
          return setErrorLogin(
            `Problemas en la asociación de datos. Error al invocar la api:  ${result.api}`,
          )
        }
        window.open(getMEUrl(), "_blank")
      })
    })
  }
  const handleSearchSubmit = (event) => {
    if (event.type === "keydown" && event.key === "Enter" && username !== "") {
      handleFind()
    }
  }
  const getProducts = () => {
    setShowCircularProgressProducts(true)
    setErrorGetProducts(false)

    getProductsUser(username, (state) => {
      if (!state || state.code) {
        setShowCircularProgressProducts(false)
        state.api
          ? setErrorGetProducts(
            `Ocurrió un error al recuperar datos para este usuario. El error ocurrio al consumir la api: ${state.api}`,
          )
          : setErrorGetProducts(
            "Ocurrió un error al recuperar datos para este usuario.",
          )

        return
      }
      window.open(
        `https://admin2.errepar.com/ProductosSuscriptores/ProductosSuscriptoresPorSuscriptor.aspx?S=${state.subscriptionNumber}`,
      )

      setShowCircularProgressProducts(false)
    })
  }

  return (
    <BoxRoot>
      <InputContainer>
        <BoxInput sx={!showTable && { height: "90vh" }}>
          <Typography
            style={{
              color: "#2C3532",
              fontSize: 20,
              fontWeight: 400,
              fontFamily: "roboto",
            }}
            sx={showTable ? { marginTop: "2rem" } : {}}
          >
            Buscar usuario en cognito. Ingresar email:
          </Typography>
          <TextField
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={handleSearchSubmit}
            placeholder={"Ej: persona@mail.com"}
          ></TextField>
          {error && <TextError>El usuario no existe en Cognito!</TextError>}
          <InputButton
            onClick={handleFind}
            variant="contained"
            sx={{ width: "100%", marginRight: "3rem", marginBottom: "2rem" }}
          >
            {showCircularProgress ? (
              <CircularProgress size="1.5rem" color="inherit" />
            ) : (
              "Buscar"
            )}
          </InputButton>
        </BoxInput>

        {showTable && (
          <BoxInput sx={{ gap: "1rem" }}>
            <Divider />
            <Typography
              style={{
                color: "#2C3532",
                fontSize: 20,
                fontWeight: 400,
                fontFamily: "roboto",
              }}
            >
              Guardar contraseña
            </Typography>
            Ingresar nueva contraseña para el usuario: {username}
            <br />
            <br />
            Recordar que debe tener 8 caracteres y al menos: <br /> una
            minúscula, una mayúscula y un numero
            <TextField
              onChange={(e) => setPassword(e.target.value)}
            ></TextField>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <InputButton
                variant="contained"
                sx={{
                  width: "10rem",
                  marginRight: "3rem",
                  marginBottom: "2rem",
                }}
                onClick={handleSetPassword}
              >
                Confirmar
              </InputButton>
              {showSuccessIcon && (
                <CheckCircleIcon fontSize="large" color="success" />
              )}
              {errorPass && <ErrorIcon fontSize="large" color="error" />}
            </Box>
            <Divider />
            <Typography
              style={{
                color: "#2C3532",
                fontSize: 20,
                fontWeight: 400,
                fontFamily: "roboto",
              }}
            >
              Iniciar sesión
            </Typography>
            {errorLogin ? <TextError>{errorLogin}</TextError> : ""}
            {errorGetProducts ? <TextError>{errorGetProducts}</TextError> : ""}
            <BoxInputsContainer>
              <InputButton
                variant="contained"
                sx={{
                  width: "33%",
                  marginRight: "1rem",
                  marginBottom: "1rem",
                  marginTop: "1rem",
                }}
                onClick={handleLogin}
              >
                {showCircularProgress ? (
                  <CircularProgress size="1.5rem" color="inherit" />
                ) : (
                  "Ver cómo el usuario"
                )}
              </InputButton>
              <Tooltip
                title={"Ver cómo el usuario Mi Estudio"}
                placement="right-start"
              >
                <InputButton
                  variant="contained"
                  sx={{
                    width: "33%",
                    marginRight: "0.5rem",
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                  onClick={handleLoginME}
                >
                  {showCircularProgressJWT3 ? (
                    <CircularProgress size="1.5rem" color="inherit" />
                  ) : (
                    "Ver cómo Mi Estudio"
                  )}
                </InputButton>
              </Tooltip>
              <Tooltip title={messageTooltip} placement="right-start">
                <InputButton
                  variant="contained"
                  sx={{
                    width: "33%",
                    marginRight: "3rem",
                    marginBottom: "1rem",
                    marginTop: "1rem",
                  }}
                  onClick={getProducts}
                >
                  {showCircularProgressProducts ? (
                    <CircularProgress size="1.5rem" color="inherit" />
                  ) : (
                    "Productos Suscriptor"
                  )}
                </InputButton>
              </Tooltip>
            </BoxInputsContainer>
            <Divider />
            <Typography
              style={{
                color: "#2C3532",
                fontSize: 20,
                fontWeight: 400,
                fontFamily: "roboto",
              }}
            >
              Doble Factor de Autenticación (2FA)
            </Typography>
            Verificar si el usuario tiene habilitado el Doble Factor de
            Autenticación
            <br />
            Puede actualizar los datos del usuario por este medio para activar
            el 2FA o editar la fecha de expiración para la funcionalidad
            &quot;Recordar dispositivo&quot;
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "1rem 0rem",
              }}
            >
              <div
                variant="contained"
                style={{
                  width: "150px",
                  height: "35px",
                  margin: "1rem 0rem",
                  display: "flex",
                  padding: "5px 0px",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#f5f5f5",
                  border: `1px solid ${status2FA ? "#08a730" : "#9a9a9a"}`,
                  color: status2FA ? "#08a730" : "#9a9a9a",
                  fontWeight: "bold",
                  borderRadius: 32,
                  fontSize: 18,
                }}
              >
                {showCircularProgressProducts ? (
                  <CircularProgress size="1.5rem" color="inherit" />
                ) : status2FA ? (
                  <>
                    <CheckCircleIcon
                      fontSize="medium"
                      color="success"
                      sx={{ marginRight: "5px" }}
                    />
                    ACTIVO
                  </>
                ) : (
                  <>
                    <InfoIcon fontSize="medium" sx={{ marginRight: "5px" }} />
                    NO ACTIVO
                  </>
                )}
              </div>

              <Tooltip
                title={
                  "Activar o desactivar el Doble Factor de Autenticación al usuario SOLO EN BASE DE DATOS. Recuerde que primero debe deshabilitarlo en la consola web de Cognito, luego modificarlo desde aquí."
                }
                placement="right-start"
              >
                <InputButton
                  variant="contained"
                  sx={{
                    width: "100px",
                    height: "30px",
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: "1rem",
                    fontSize: 14,
                    fontWeight: 400,
                    padding: "0px",
                  }}
                  onClick={changeStatus2FA}
                >
                  {showCircularProgressProducts ? (
                    <CircularProgress size="1.5rem" color="inherit" />
                  ) : (
                    <>
                      <EditIcon
                        sx={{
                          marginRight: "5px",
                          fontSize: 16,
                          color: "#ffff",
                        }}
                      />
                      editar
                    </>
                  )}
                </InputButton>
              </Tooltip>
            </div>
            Actualizar la fecha de expiración de un dispositivo recordado por el usuario:
            <br />
            Hasta que día se recordará el
            dispositivo y no se pedirá nuevamente al usuario validar la identidad mediante el 2FA.
            Solo es válido en el caso de que el usuario tenga algún dispositivo recordado.
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "1rem 0rem",
              }}
            >

              <DatePicker
                id="date"
                selected={expiredDate}
                onChange={(date) => {
                  setexpiredDate(date)
                  setdisabledExpiredDateBoolean(date.toISOString().split("T")[0] === disableexpiredDate)
                }}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/aaaa"
                showYearDropdown
                scrollableYearDropdown
                locale={es}
              />


              <Tooltip
                title={
                  "Si el usuario tiene algún dispositivo recordado y la fecha de expiración está vencida, se pedirá al usuario valide su identidad mediante el 2FA"
                }
                placement="right-start"
              >
                <InputButton
                  variant="contained"
                  sx={{
                    width: "140px",
                    height: "25px",
                    display: "flex",
                    justifyContent: "center",
                    marginLeft: "1rem",
                    fontSize: 14,
                    fontWeight: 400,
                    padding: "0px",
                  }}
                  onClick={changeExpiredDate2FA}
                  disabled={disabledExpiredDateBoolean}
                >
                  {showCircularProgressProducts ? (
                    <CircularProgress size="1.5rem" color="inherit" />
                  ) : (
                    <>
                      <EditIcon
                        sx={{
                          marginRight: "5px",
                          fontSize: 16,
                          color: "#ffff",
                        }}
                      />
                      actualizar
                    </>
                  )}
                </InputButton>
              </Tooltip>

            </div>
            <Divider />
            <Typography
              style={{
                color: "#2C3532",
                fontSize: 20,
                fontWeight: 400,
                fontFamily: "roboto",
                marginBottom: "1rem",
              }}
            >
              Datos del usuario en Cognito
            </Typography>
          </BoxInput>
        )}
      </InputContainer>

      {showTable && (
        <BoxTable>
          <Table>
            <TableHead
              sx={{
                background: "#1C846F",
              }}
            >
              <TableRow>
                <Fragment>
                  <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                    Atributo
                  </TableCell>
                  <TableCell
                    sx={{ color: "white", fontWeight: "bold" }}
                    align="left"
                  >
                    Valor
                  </TableCell>
                </Fragment>
              </TableRow>
            </TableHead>
            <TableBody>
              {showTable &&
                user.map((element) => (
                  <TableRow key={element.Name}>
                    <TableCell>{element.Name}</TableCell>
                    <TableCell>{element.Value}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </BoxTable>
      )}
      <ConfirmModalCognito
        openModal={openModal}
        handleClose={() => setopenModal(false)}
        handleConfirmFunction={handleUpdatetUserAccountData}
        isActivate={status2FA}
      />
    </BoxRoot>
  )
}

export default UserAdministrationDesktop
